/**
 * Thin wrappers around `window.location` mutations so that tests can mock them
 * at the module level without trying to redefine the non-configurable
 * `window.location` property (which throws in real Chromium).
 */

export function locationAssign(url: string): void {
    window.location.assign(url);
}

export function locationReload(): void {
    window.location.reload();
}
